module.exports = __webpack_public_path__ + "img/double_chevron_down.86a5f2a0.svg";